<template>
  <template v-if="actions.length">
    <ul class="mpf-grid-row mpf-card-group">
      <li v-for="(action, i) in visibleActions" class="mpf-grid-column-full mpf-card-group__item">
        <!-- just assigning the props needed and not v-binding a whole action{} into it -->
        <MpfCard
          :key="`action-${i}-${action.href}`"
          heading-level="2"
          heading-classes="mpf-heading-m"
          :heading="action.heading"
          :description="action.description"
          :href="action.href"
          :disabled="action.status === 'closed' || action.status === 'paused'"
          :paused="action.status === 'paused'"
          :paused-status-description="action.pausedStatusDescription"
          :tagText="tagText(action)"
          :isNhsJurisdiction="tenant.jurisdiction === 'england-nhs'"
          :organisationPhoneNumber="tenant.localOrganisation.phone"
          @click="$router.push(action.href)"
        >
          <MpfNotificationBanner
            v-if="action.status === 'paused'"
            :additional-text="action.pausedStatusDescription"
            :isNhsJurisdiction="tenant.jurisdiction === 'england-nhs'"
            :organisationPhoneNumber="tenant.localOrganisation.phone"
          >
            <p class="mpf-u-margin-bottom-3" v-if="action.pauseReason">{{ action.pauseReason }}</p>
            <p class="mpf-u-margin-bottom-3">If your request is an emergency or you're not sure:</p>
            <ul class="mpf-u-margin-bottom-0">
              <li v-if="tenant?.localOrganisation.phone">
                call the surgery on
                <a href="tel:{{ tenant?.localOrganisation.phone }}" class="mpf-link">{{
                  tenant?.localOrganisation.phone
                }}</a>
              </li>
              <li v-if="isNhsJurisdiction">
                if the surgery is closed, phone <a href="tel:111">111</a> or go online to
                <a
                  href="https://111.nhs.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="mpf-link"
                  >Get help for your symptoms - NHS 111</a
                >
              </li>
              <li>in an emergency, phone 999 or go to A&amp;E</li>
            </ul>
          </MpfNotificationBanner>
        </MpfCard>
      </li>
    </ul>
  </template>
  <template v-else-if="!apiLoading">
    <p>No tenant in URL. {{ error }}</p>
  </template>
</template>
<script setup lang="ts">
  import { computed } from 'vue';
  import { useTenantStore } from '../../stores/useTenantStore';
  import { storeToRefs } from 'pinia';
  import {
    formatFriendlyOpeningDatePhrase,
    formatFriendlyClosingDatePhrase,
  } from '../helpers/dates';
  import MpfCard from '../components/MpfCard/MpfCard.vue';
  import { ActionItem } from '../../types/tenant';

  import MpfNotificationBanner from '../components/MpfNotificationBanner/MpfNotificationBanner.vue';

  const tenantStore = useTenantStore();
  const { actions, apiLoading, error, tenant, isNhsJurisdiction } = storeToRefs(tenantStore);

  // TODO:move to composable

  const tagText = (action: ActionItem) => {
    return action.status === 'always-open'
      ? null
      : action.status === 'open'
        ? formatFriendlyClosingDatePhrase(`${action.nextCloses}`)
        : formatFriendlyOpeningDatePhrase(`${action.nextOpens}`);
  };

  const visibleActions = computed(() => {
    return actions.value.filter((action) => action.status !== 'disabled');
  });
</script>
